import * as React from 'react'

import { PayrollPolicyPeriodTypesPeriodTypeEnum } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { MissingCategoriesModal } from './_MissingCategoriesModal'
import ReimburseModal from './_ReimburseModal'

interface AddToPayrollModalProps {
  onSubmit: (period: PayrollPolicyPeriodTypesPeriodTypeEnum) => void
  onClose: () => void
  currentPeriodOpen: boolean
  selectedCategories: string[]
  availableCategories?: string[]
}

const AddToPayrollModal = ({
  onSubmit,
  onClose,
  currentPeriodOpen,
  selectedCategories,
  availableCategories,
}: AddToPayrollModalProps) => {
  const allExistingCategories =
    availableCategories &&
    selectedCategories.every((category) => availableCategories.includes(category))

  if (!allExistingCategories) return <MissingCategoriesModal onClose={onClose} />

  return (
    <ReimburseModal currentPeriodOpen={currentPeriodOpen} onSubmit={onSubmit} onClose={onClose} />
  )
}

export default observer(AddToPayrollModal)
